"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForeignNode = exports.FOREIGN_REFERENCE_SEPARATOR = void 0;
const base_1 = require("./base");
const sheet_db_1 = require("../../sheet_db");
const column_node_1 = require("./column.node");
exports.FOREIGN_REFERENCE_SEPARATOR = '!';
const cleanForeignReference = (rawText) => {
    const cleanedToken = (0, column_node_1.cleanColumnDelimiter)(rawText);
    const splitted = cleanedToken.split(exports.FOREIGN_REFERENCE_SEPARATOR);
    if (splitted.length !== 2)
        throw new Error('Invalid text for foreign reference: ' + rawText);
    return {
        tabToken: splitted[0],
        columnToken: splitted[1],
    };
};
class ForeignNode extends base_1.LeafNode {
    context;
    tabToken;
    columnToken;
    dataType;
    constructor(tabsContext, originalNode, parent) {
        super(originalNode, parent);
        const { tabToken, columnToken } = cleanForeignReference(this.token);
        this.tabToken = tabToken;
        this.columnToken = columnToken;
        this.context = tabsContext;
        this._endPosition = originalNode.symbol.stop;
        this._treeNodeType = base_1.TreeNodeType.COLUMN_NODE;
    }
    get tab() {
        const tabId = this.abstractText?.split(exports.FOREIGN_REFERENCE_SEPARATOR)[0] ?? this.tabToken;
        return this.context.getTabById(tabId);
    }
    get column() {
        const tab = this.tab;
        if (!tab)
            return;
        const columnId = this.abstractText?.split(exports.FOREIGN_REFERENCE_SEPARATOR)[1] ?? this.columnToken;
        return this.context.getColumnById(columnId, tab.id);
    }
    accept(v) {
        if (v.visitForeign)
            v.visitForeign(this);
    }
    translate({ isOut }) {
        if (isOut)
            this.formatForeignOut();
        else
            this.formatForeignIn();
        return this.translation;
    }
    /*
      {tab!colname} -> __10!4__
      __tab!colname__ -> __10!4__
  
      Uses the cleaned tokens as the column and tab names
    */
    formatForeignIn() {
        const tabByName = this.context.getTabByName(this.tabToken);
        const colByName = tabByName?.columnsByName.get(this.columnToken);
        // Referenced column not founded
        if (!tabByName || !colByName) {
            this.abstractText = `${tabByName?.id ?? this.tabToken}${exports.FOREIGN_REFERENCE_SEPARATOR}${this.columnToken}`;
            this.translation = `__${this.abstractText}__`;
            this.dataType = sheet_db_1.ColumnType.STRING;
            return this.translation;
        }
        this.abstractText = `${tabByName.id}${exports.FOREIGN_REFERENCE_SEPARATOR}${colByName.column_id}`;
        this.translation = `__${this.abstractText}__`;
        return this.translation;
    }
    /*
      __10!4__ -> {tab!colname}
      {10!4} -> {tab!colname}
  
      Uses the cleaned tokens as the column and tab ids
    */
    formatForeignOut() {
        // Referenced column not founded
        if (!this.tab || !this.column) {
            this.abstractText = `${this.tabToken}${exports.FOREIGN_REFERENCE_SEPARATOR}${this.columnToken}`;
            this.translation = `{${this.abstractText}}`;
            this.dataType = sheet_db_1.ColumnType.STRING;
            return this.translation;
        }
        this.abstractText = `${this.tab.name}${exports.FOREIGN_REFERENCE_SEPARATOR}${this.column.name}`;
        this.translation = `{${this.abstractText}}`;
        return this.translation;
    }
    getReturnType() {
        return this.dataType || sheet_db_1.ColumnType.STRING;
    }
}
exports.ForeignNode = ForeignNode;
